export const getLabelsForQuestion = ({
  t,
  type,
  rangeKeys,
  yesIsBad = false
}) => {
  switch (type) {
    case 'zeroToTen':
      if (!rangeKeys) {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      } else {
        return rangeKeys.map((value, i) => charForRangeOrder(i))
      }
    case 'yesOrNoOrDontKnow':
      return [
        t('categoryDetails.chartLabel.noLabel'),
        t('categoryDetails.chartLabel.yesLabel'),
        t('categoryDetails.chartLabel.dontKnowLabel')
      ]
    case 'yesOrNo':
      if (yesIsBad) {
        return [
          t('categoryDetails.chartLabel.yesLabel'),
          t('categoryDetails.chartLabel.noLabel')
        ]
      } else {
        return [
          t('categoryDetails.chartLabel.noLabel'),
          t('categoryDetails.chartLabel.yesLabel')
        ]
      }
    default:
      return ''
  }
}
export const charForRangeOrder = (value) => {
  switch (parseInt(value)) {
    case 1:
      return 'b'
    case 2:
      return 'c'
    case 3:
      return 'd'
    case 4:
      return 'e'
    case 5:
      return 'f'
    case 6:
      return 'g'
    case 7:
      return 'h'
    case 8:
      return 'i'
    case 9:
      return 'j'
    case 10:
      return 'k'
    default:
      return 'a'
  }
}
